<template>
  <div>
    <HeaderPage></HeaderPage>
    <div class="content">
      <SlideShow></SlideShow>
    </div>
    <div style="width:80%;margin:auto">
      <!-- <div class="slide">
        <img src="@/assets/img/aboutus.jpg" alt />
      </div> -->
      <CompanyPage></CompanyPage>
    </div>

    <FooterPage></FooterPage>
  </div>
</template>

<script>
import HeaderPage from "@/components/HeaderPage.vue";
import SlideShow from "@/components/SlideShow.vue";
import FooterPage from "@/components/FooterPage.vue";
import CompanyPage from "@/components/CompanyPage.vue";
export default {
  name: "CompanyProfile",
  components: {
    HeaderPage,
    SlideShow,
    FooterPage,
    CompanyPage
  },
  methods: {}
};
</script>

<style scoped>
.slide img {
  width: 100%;
  height: 500px;
}
.content {
  width: 80%;
  margin: auto;
}
</style>